/* eslint-disable */
import { request } from '@umijs/max';

import type { ApiResponse } from '@/types/pagination';

export interface WhatsAppContactItem {
  url: string;
  title: string;
}

export interface SocialLinkItem {
  href: string;
  ariaLabel: string;
  icon: string;
  alt: string;
}

export interface SiteDataItem {
  id: number;
  wechatImg?: string | null;
  whatsapps: WhatsAppContactItem[];
  socialLinks: SocialLinkItem[];
  email?: string | null;
  createTime?: string;
  updateTime?: string;
}

/** 获取站点 siteData 数据（只会返回一条） */
export async function apiGetSiteData(params?: Record<string, unknown>) {
  return request<ApiResponse<SiteDataItem>>('/api/site-data', {
    method: 'GET',
    params,
  });
}

export interface UpdateSiteDataPayload {
  id: number;
  wechatImg?: string | null;
  whatsapps: WhatsAppContactItem[];
  socialLinks: SocialLinkItem[];
  email?: string | null;
}

export async function apiUpdateSiteData(data: UpdateSiteDataPayload) {
  return request<ApiResponse<void>>(`/api/site-data/${data.id}`, {
    method: 'PUT',
    data,
  });
}

/** OSS 上传（保存时才调用） */
export async function apiUploadOss(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return request<ApiResponse<string>>('/api/oss/upload', {
    method: 'POST',
    data: formData,
    requestType: 'form',
  });
}
